module.exports = __webpack_public_path__ + "img/logo-emma-powered-by.25a0f98b.png";